import { Component } from 'react'
import PropTypes from 'prop-types'

import { AlertText } from 'components/common/Alert'
import Email from 'components/authentication/form-fields/Email'
import SignedOutForm, {
  SignedOutFormContainer,
  UpperBackText
} from 'components/authentication/SignedOutForm'
import authenticationAPI from 'api/authentication'
import { messageFromResponseError } from 'utils/strings'
import toast from 'lib/toast'

export default class RequestPasswordReset extends Component {
  static propTypes = {
    history: PropTypes.object,
    requestPasswordReset: PropTypes.func
  }

  static defaultProps = {
    requestPasswordReset: authenticationAPI.requestPasswordReset
  }

  state = { email: '' }

  handleChange = ({ target }) => this.setState({ email: target.value })

  handleSubmit = event => {
    event.preventDefault()
    this.props
      .requestPasswordReset(event.target.email.value)
      .then(() => {
        toast({
          type: 'info',
          text: (
            <AlertText data-test-request-password-success>
              Password reset email sent
            </AlertText>
          )
        })
        this.props.history.push('/')
      })
      .catch(err => {
        toast({
          type: 'error',
          text: (
            <AlertText data-test-request-password-error>
              {messageFromResponseError(
                err,
                'Unable to request a password reset. Please try again later.'
              )}
            </AlertText>
          )
        })
      })
  }

  render() {
    return (
      <SignedOutFormContainer>
        <UpperBackText to="/login">Back to login</UpperBackText>
        <SignedOutForm title="Reset Password" onSubmit={this.handleSubmit}>
          <Email email={this.state.email} handleChange={this.handleChange} />
        </SignedOutForm>
      </SignedOutFormContainer>
    )
  }
}
